import login from './login'
import user from './user'
import teacher from './teacher'
import confirmIdentity from './confirmIdentity'

const pageRouters = [
  login,
  user,
  teacher,
  confirmIdentity
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js